import React from "react";
import { Alert, Text, TouchableOpacity, View } from "react-native";
import { normalize } from "../utils/normalize";
import professions from "../constants/lov/professions";
import colors from "../constants/colors";

const CategoryTab = (props) => {
  return (
    <View style={{ marginTop: 20 }}>
      <View style={styles.tabContainer}>
        {professions.slice(0, 11).map((prof, idx) => {
          if (prof.id > 99) return null;
          return (
            <TouchableOpacity
              style={{
                ...styles.tab,
                borderBottomColor:
                  props.selectedCategoryID === prof.id
                    ? colors.primary
                    : "transparent",
              }}
              onPress={() => {
                if (true) {
                  props.setSelectedCategory(prof.slug.split("-")[0]);
                  props.setSelectedCategoryID(prof.id);
                } else {
                  if (idx !== 0) Alert.alert("Coming Soon!");
                }
              }}
            >
              <Text
                style={{
                  ...styles.tabText,
                  color:
                    props.selectedCategoryID === prof.id ? "black" : "#ccc",
                }}
              >
                {prof.name}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>

      <View style={styles.tabContainer}>
        {professions.slice(11, 20).map((prof, idx) => {
          if (prof.id > 99) return null;
          return (
            <TouchableOpacity
              style={{
                ...styles.tab,
                borderBottomColor:
                  props.selectedCategoryID === prof.id
                    ? colors.primary
                    : "transparent",
              }}
              onPress={() => {
                if (true) {
                  props.setSelectedCategory(prof.slug.split("-")[0]);
                  props.setSelectedCategoryID(prof.id);
                } else {
                  if (idx !== 0) Alert.alert("Coming Soon!");
                }
              }}
            >
              <Text
                style={{
                  ...styles.tabText,
                  color:
                    props.selectedCategoryID === prof.id ? "black" : "#ccc",
                }}
              >
                {prof.name.replace(`\n`, " ")}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

const styles = {
  tabContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    marginBottom: 12,
    flex: 1,
  },
  tab: {
    borderBottomWidth: 2,
    borderRadius: 0,
    flexDirection: "column",
    justifyContent: "center",
    // height: 50,
    // flexGrow: 1,
    // marginHorizontal: 5,
    // flexBasis: "15%",
  },
  tabText: {
    fontSize: normalize(12),
    fontWeight: "bold",
    textAlign: "center",
  },
};

export default CategoryTab;
